<!-- ── Legend : status radios driving the map filter ────────────────────────── -->
<aside class="holes-view__legend" data-attr="holes-legend-state">
  <app-holes-legend-panel>
    <app-radiobox
      class="state-legend"
      size="small"
      iconPosition="left"
      [fullWidth]="true"
      [options]="legendItems()"
      [ngModel]="state.statusFilter()"
      (ngModelChange)="onFilterChange($event)"
      data-attr="holes-state-legend">
      @for (item of legendItems(); track item.value) {
        <ng-template [appRadioIcon]="item.value">
          <img class="state-legend__icon" [src]="item.icon" alt="">
        </ng-template>
      }
    </app-radiobox>
  </app-holes-legend-panel>
</aside>

<!-- ── Panel : progress chips + hole table ──────────────────────────────────── -->
<section class="holes-view__panel" data-attr="holes-panel-state">

  <!-- Progress chips are read-only: the table columns are the user's choice (column picker), nothing changes them automatically -->
  <div class="holes-view__head">
    <div class="state-panel__chips">
      <app-progress-chip
        [percent]="drilled().percent"
        [label]="'HOLES_TAB.DRILLED_PROGRESS' | translate"
        [title]="drilled().count + ' / ' + drilled().total"
        data-attr="holes-chip-drilled" />
      <app-progress-chip
        [percent]="loaded().percent"
        [label]="'HOLES_TAB.LOADED_PROGRESS' | translate"
        [title]="loaded().count + ' / ' + loaded().total"
        data-attr="holes-chip-loaded" />
    </div>
    <div class="holes-view__columns columns-popup-wrapper" #columnsBtn>
      <app-button
        variant="secondary" color="amarante" size="small"
        ButtonSize = "small"
        [addLabel]="false" [addIconLeft]="true"
        [attr.title]="'QAQC_TAB.COLUMNS' | translate"
        (click)="openColumns(columnsBtn)"
        [state]="columnsOpen() ? 'pressed' : 'default'"
        [class.no-hover]="columnsOpen()"
        data-attr="holes-btn-columns">
        <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
        <img slot="icon-left-active" src="assets/icon/new_icon/settings_white.svg" alt="" />
      </app-button>
      @if (columnsOpen()) {
      <app-popup-panel
        [isOpen]="columnsOpen()"
        size="small"
        class="popup-panel-position"
        [ngStyle]="{ top: columnsPopupPos().top, right: columnsPopupPos().right }"
        (closed)="columnsOpen.set(false)">
        <span slot="header">{{ 'QAQC_TAB.COLUMNS' | translate }}</span>
        <div class="columns-popup__all">
          <app-checkbox
            size="small"
            [label]="'GLOBAL.SELECT_ALL' | translate"
            [ngModel]="allColumnsVisible()"
            (changed)="toggleAllColumns()" />
        </div>
        <app-scrollable>
          <div class="columns-popup__list">
            @for (column of allColumns; track column.key) {
              <app-checkbox
                size="small"
                [label]="column.label | translate"
                [ngModel]="visibleColumnKeys().has(column.key)"
                [state]="isLastVisibleColumn(column.key) ? 'disabled' : 'default'"
                (changed)="toggleColumn(column.key)"
                [attr.data-attr]="'holes-check-column-' + column.key" />
            }
          </div>
        </app-scrollable>
      </app-popup-panel>
      }
    </div>
  </div>

  <div class="holes-view__table">

    @if (rows().length) {
      @if (state.loadingError()) {
        <div class="state-panel__notice">
          <span>{{ 'HOLES_TAB.QUALITY_LOADING_ERROR' | translate }}</span>
          <button type="button" class="state-panel__retry" (click)="retryLoading()">{{ 'HOLES_TAB.RETRY' | translate }}</button>
        </div>
      }
      <app-data-table
        [data]="rows()"
        [columns]="visibleColumns()"
        [searchTerm]="state.searchTerm()"
        [clickable]="true"
        rowKey="publicGuid"
        highlightedRowKey="publicGuid"
        [highlightedRowValue]="state.selectedHoleId()"
        (selectionLigne)="onRowClick($event)"
        sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
        sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
        sortIconFilter="brightness(0)">
        <ng-template tableCell="hasSurveyed" let-row>{{ row.hasSurveyed ? '✓' : '–' }}</ng-template>
        <ng-template tableCell="hasWater"    let-row>{{ row.hasWater    ? '✓' : '–' }}</ng-template>
        <ng-template tableCell="hasTube"     let-row>{{ row.hasTube     ? '✓' : '–' }}</ng-template>
      </app-data-table>
    } @else if (!state.isLoading()) {
      <p class="holes-view__empty">{{ 'HOLES_TAB.NO_HOLES' | translate }}</p>
    }
  </div>

</section>
